var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.15974 12.3515L9.7852 5.72604C9.92333 5.58791 10.1107 5.51031 10.306 5.51031C10.5014 5.51031 10.6887 5.58791 10.8269 5.72604C10.965 5.86418 11.0426 6.05153 11.0426 6.24688C11.0426 6.44223 10.965 6.62958 10.8269 6.76772L5.45748 12.1362L19.8761 12.1362C20.0714 12.1362 20.2586 12.2137 20.3967 12.3518C20.5347 12.4899 20.6123 12.6771 20.6123 12.8723C20.6123 13.0676 20.5347 13.2548 20.3967 13.3929C20.2586 13.5309 20.0714 13.6085 19.8761 13.6085L5.45748 13.6085L10.8269 18.977C10.965 19.1151 11.0426 19.3025 11.0426 19.4978C11.0426 19.6932 10.965 19.8805 10.8269 20.0186C10.6887 20.1568 10.5014 20.2344 10.306 20.2344C10.1107 20.2344 9.92333 20.1568 9.7852 20.0186L3.15974 13.3932C3.09129 13.3248 3.03699 13.2436 2.99995 13.1542C2.9629 13.0649 2.94383 12.9691 2.94383 12.8723C2.94383 12.7756 2.9629 12.6798 2.99995 12.5904C3.03699 12.5011 3.09129 12.4199 3.15974 12.3515Z",
    fill: "#7C63A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.22559dc89bad98ea4f13cdd273d62071.svg";
export { ForwardRef as ReactComponent };